import { Survey, SurveyReport, SurveySegment, SelectionReport, SurveyTopic, SelectionStats } from "../../DTOs";
import { getSurveyQuestionIndex, surveyHelper, surveyReportHelper } from "../../helpers";
import { AggregatedSurveyReport } from "./AggregatedSurveyReport";
import { IndicatorReport } from "./IndicatorReport";
import { ThemeReport } from "./ThemeReport";
import { segmentListsMatch } from "./segmentationHelpers";

export const surveyTopicModule = {
    getSurveyTopics
};

function getSurveyTopics(survey:Survey, surveyReport:SurveyReport, segmentFilter:SurveySegment[][]) {
    const allQuestions = surveyHelper.getAllSurveyQuestions(survey);

    let selectionReports: SelectionReport[] = [];
    // No segment filter selected
    if(segmentFilter.length === 0){
        // Survey doesn't have segmentations OR not segments int filter - return all data
        selectionReports = surveyReport.selectionReports;
    }
    else{
        for (const cr of surveyReport.selectionReports) {
            for (const fr of segmentFilter) {
                if (segmentListsMatch(fr, cr.segments))
                    selectionReports.push(cr);
            }
        }
    }

    const report = AggregatedSurveyReport.buildData(allQuestions.map(q => q.question), selectionReports);
    const themeReport = new ThemeReport(survey, report);
    
    const topics:SurveyTopic[] = [];

    topics.push(...themeReport.data.map(d => {
        const themeIndex = survey.themes.findIndex(t => t.name === d.theme);
        return {
            
            linkType: 'theme', 
            themeIndex,
            questionsInTheme:survey.themes[themeIndex].questions.length,
            data:{
                title: d.theme,
                selections: d.selections
            }
        } as SurveyTopic
    }));

    const indicatorReport = new IndicatorReport(survey, report);
    topics.push(...indicatorReport.data.map(d => {
        const questionsWithIndicator = allQuestions.filter(q => q.question.indicators.find(i => i === d.indicator)).length;
        return {
            linkType: 'indicator', 
            indicator: d.indicator,
            questionsWithIndicator,
            data:{
                title: d.indicator,
                selections: d.selections
            }
        } as SurveyTopic
    }));
    
    topics.push(...report.map((d, index) => {
        const indices = getSurveyQuestionIndex(survey, index);
        if (indices === null)
            throw new Error('Unexpected outcome');
        return {
            linkType: 'question', 
            themeIndex: indices.themeIndex, 
            questionIndex: indices.questionIndex,
            data:{
                title: allQuestions[index].question.title,
                selections: d.selections
            }
        } as SurveyTopic
    }));

    // If filter is empty but survey does indeed have segmentations - reset all selections
    if(segmentFilter.length === 0 && survey.segmentations.length > 0){
        for(const t of topics)
            t.data.selections = new SelectionStats(surveyReportHelper.createNewSelectionSummary())
    }

    return topics;
}